import * as React from 'react';
import { Component } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import Table from 'react-bootstrap/Table'
import UserRow from "../users-list/UserRow"
import NouveauMessageModal from "../user-messages/NouveauMessageModal"
import FormGroup from '@material-ui/core/FormGroup';
import axios from 'axios';
import CommonCheckBox from '../common/CommonCheckBox'
import ReactPaginate from 'react-paginate';
import "../../assets/styles.css";
import BlueButton from "../common/BlueButton"
import SuccessDialog from "../../components/common/SuccessDialog"
import  WebServiceList  from '../../webservices/WebServiceList'



export default class UsersListTable extends Component {

  

  constructor(props) {
    super(props);
    // this.userRowRef = React.createRef();
    this.onAllSelectedChanged = this.onAllSelectedChanged.bind(this);

    this.onMessageSent = this.onMessageSent.bind(this);
    this.setModalShow = this.setModalShow.bind(this);
    this.setModalHide = this.setModalHide.bind(this);
    this.onCheckChanged = this.onCheckChanged.bind(this);
    this.onDataChanged = this.onDataChanged.bind(this);
    this.state = {
      itemPerPage: 20,
      PageCount: 0,
      data: [],
      user_list: [],
      modalShow: false,
      sending_list: [],
      reset: false,
      isALLSelected: false,
      startingIndex: 0,
      endingIndex: 20,
      message_sent: false,
      no_selection : false
    }

  }

  componentDidMount() {
    console.log("CALL getAllUsers");
    let theToken = localStorage.getItem("token");
    const headers = {
      'Content-Type': 'application/json',
      'x-access-token': theToken,
    };
    axios.get(WebServiceList.WsGetUsersList(),{headers}).then(response => {

      let theUserList = response.data;
      this.setState({
        user_list: theUserList,
        PageCount: Math.ceil(theUserList.length / this.state.itemPerPage)
      });
      this.onDataChanged();
    }).catch(function (error) {
      console.log("Error:" + error);
    })
  }

  onCheckChanged(userId, isChecked) {
    console.log("-----> onChecked: " + isChecked + " - UserId:" + userId);
    let theUserIdList = this.state.sending_list;
    if (isChecked) {
      if (theUserIdList.indexOf(userId) === -1) theUserIdList.push(userId);
      console.log("Add to theUserIdList:" + JSON.stringify(theUserIdList));
     
    } else {

      var index = theUserIdList.indexOf(userId);
      if (index > -1) {
        theUserIdList.splice(index, 1);
      }
      console.log("Remove from theUserIdList:" + JSON.stringify(theUserIdList))
    }

    if(theUserIdList.length>0){
      if(this.state.user_list.length == theUserIdList.length){
        console.log("--------> this.state.user_list.length == theUserIdList.length")
        this.setState({isALLSelected:true})
      }else{
        this.setState({isALLSelected:false})
      }
     
    }else{
      this.setState({isALLSelected:false})
    
    }
    this.setState({sending_list:theUserIdList});
    this.setState({ no_selection : false});
    this.setState({modalShow:false})
  }

  userList() {
    if (this.state.user_list && this.state.user_list.length > 0) {
      return this.state.data.map((user, idx) => (
        <UserRow sending_list={this.state.sending_list} reset={this.state.reset} user={user} key={idx} onCheckBoxCallback={this.onCheckChanged} />
      ))
    } else {
      return (<tr><td>Pas d'utilisateurs enregistrés</td></tr>)
    }

  }

  setModalShow() {
    console.log("setModalShow")

    this.setState({message_sent:false ,no_selection:false})
    if(this.state.sending_list.length>0){
      this.setState({ modalShow: true})
    }else{
      this.setState({ modalShow: false})
      this.setState({ no_selection: true})
    }
   
  }

  setModalHide() {
    console.log("setModalHide")
    this.setState({ modalShow: false })

  }

  onMessageSent() {
    console.log("onMessageSent");

    this.setState({ modalShow: false, message_sent: true });
    this.setState({ reset: true })
    this.onAllSelectedChanged(false)
  }


  handlePageClick = data => {
   
    let selected = data.selected;
    let offset = Math.ceil(selected * this.state.itemPerPage);

    let theStartingIndex = offset;
    let theEndIndex = offset + this.state.itemPerPage;

    /**
     * This is the key
     */
    this.setState({ data: [] });
    this.setState({ modalShow: false });
    this.setState({ startingIndex: theStartingIndex, endingIndex: theEndIndex }, () => {
      this.onDataChanged();
    });
  };

  onDataChanged() {
    let theNewList = this.state.user_list.slice(this.state.startingIndex, this.state.endingIndex);
    this.setState({ data: theNewList })

    this.userList();
  }

  onAllSelectedChanged(isChecked) {
    console.log("onAllSelectedChanged:" + isChecked)
    if (isChecked) {
      /**
      * This is the key
      */
      this.setState({ data: [] });

      let theUsersIds = [];
      for (let i = 0; i < this.state.user_list.length; i++) {
        theUsersIds.push(this.state.user_list[i].id);
      }

      console.log("all Users List "+JSON.stringify(theUsersIds))
      this.setState({sending_list: theUsersIds});
      this.setState({ no_selection : false});
      this.setState({
        modalShow: false,
        isALLSelected: isChecked
      }, () => {
        this.onDataChanged();
      });
    }else{

       /**
      * This is the key
      */
     this.setState({ data: [] });

     
     this.setState({sending_list: []});

     this.setState({
      message_sent : false,
       modalShow: false,
       no_selection : false,
       isALLSelected: false
     }, () => {
       this.onDataChanged();
     });


    }
  }

  render() {
    return (


        <Card small className="mb-3 pl-2 pr-2" >
            <CardHeader className="border-bottom"><Row>
              <Col xl="10"  lg="9" md="6" sm="6">  <h6 className="m-0">Liste des utilisateurs</h6></Col>
              <Col xl="2"  lg="3" md="6" sm="6">  <BlueButton onClick={this.setModalShow} className="ml-auto mb-2 mt-2" >
                  Nouveau Message
                  </BlueButton></Col>
            </Row>
          
          
            </CardHeader>
            <CardBody className="p-0 pl-2 pr-2">


              <Table className="table mb-0 " responsive="sm" >
                <thead className="bg-light">
                  <tr>
                    <th style={{ width: '3%' }}  scope="col" className="border-0 ">
                    <CommonCheckBox label="" onCheckChanged={this.onAllSelectedChanged} isChecked={this.state.isALLSelected} />
                    </th>
                    <th style={{ width: '40%' }} scope="col" className="border-0 pb-4">
                      E-mail
                    </th>
                    <th style={{ width: '40%' }} scope="col" className="border-0 pb-4">
                      Date d'inscription
                    </th>
                    <th style={{ width: '17%' }} scope="col" className="border-0 pb-4">
                      Messages
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.userList()}
                </tbody>

              </Table>
              <Row className="p-0 m-0">
                <Col md="8"></Col>
                <Col md="4">
                  <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.PageCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={1}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'} 
                  />
                </Col>
              </Row>

              <NouveauMessageModal
                onClosePopUp={this.setModalHide}
                messageSentCallback={this.onMessageSent}
                usersId={this.state.sending_list}
                show={this.state.modalShow}
                open={this.state.modalShow} />

              <SuccessDialog title="Message envoyé" message="Votre message a été envoyé avec success" didOpen={this.state.message_sent} />
              <SuccessDialog title="Pas d'utilisateur séléctionné" message="Vous devez séléctionner au moins un utilisateur pour envoyer un message" didOpen={this.state.no_selection} />
           
            </CardBody>
          </Card>
    

    )
  }
}

